import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { isFullAccess } from "src/auth/ProtectedRoutes";
import useAuth from "src/hooks/useAuth";
import Controls from "src/components/form/controls/Controls";

const AccessControlPanel = ({ children, handleOpenPopup }) => {
  const { auth } = useAuth();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        {isFullAccess(auth?.permissions) && (
          <Controls.Button
            text="Add New"
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => {
              handleOpenPopup(null, "", "");
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AccessControlPanel;
